export default [
  {
    description: 'Default',
  },
  {
    description: 'Promotion Price Free of charge',
    promotionProcessing: true,
    price: {
      promotion: {
        amount: 0,
        currency: 'EUR',
        priceDisplay: null,
        value: '0',
      },
    },
  },
  {
    description: 'Regular Price Free of charge',
    price: {
      promotion: null,
      amount: 0,
      currency: 'EUR',
      priceDisplay: null,
      value: '0',
    },
  },
  {
    description: '!isExact',
    price: {
      isExact: false,
    },
  },
  {
    description: '!isExact & Regular Price Free of charge',
    price: {
      isExact: false,
      promotion: null,
      amount: 0,
      currency: 'EUR',
      priceDisplay: null,
      value: '0',
    },
  },
  {
    description: 'promotionProcessing TRUE',
    promotionProcessing: true,
  },
  {
    description: 'With RegularOverrideText',
    overrideTextRegular: 'foo bar foo bar <b>regularPriceOverrideText</b> foo bar foo bar',
  },
  {
    description: 'With PromotionOverrideText',
    overrideTextPromotion: 'foo bar foo bar <b>promotionPriceOverrideText</b> foo bar foo bar',
  },
  {
    description: 'With EMPTY PromotionOverrideText',
    overrideTextPromotion: '',
  },
  {
    description: 'With EMPTY RegularOverrideText',
    overrideTextRegular: '',
  },
  {
    description: 'Price chargingIntervalFactor = 3, chargingIntervalUnit = 2 (Days)',
    price: {
      chargingIntervalUnit: 1,
      chargingIntervalFactor: 3,
    },
  },
  {
    description: 'With setupPrice',
    price: {
      setupPrice: {
        priceDisplay: '8,88 €',
      },
    },
  },
  {
    description: 'With chargingIntervalOverrideText',
    price: {
      chargingIntervalOverrideText: 'monatlich',
    },
  },
  {
    description: 'noFormatting',
    noFormatting: true,
  },
  {
    description: 'One-Time-Subscription',
    subscriptionType: 2,
  },
];
